import React, { Suspense, lazy } from 'react';
import Header from './components/Header';
import SalesPopNotification from './components/SalesPopNotification';
const HeroSection = lazy(() => import('./components/HeroSection'));
const ProblemSolution = lazy(() => import('./components/ProblemSolution'));
const Features = lazy(() => import('./components/Features'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const Expert = lazy(() => import('./components/Expert'));
const Offer = lazy(() => import('./components/Offer'));
const Guarantee = lazy(() => import('./components/Guarantee'));
const FAQ = lazy(() => import('./components/FAQ'));
const Footer = lazy(() => import('./components/Footer'));
const LazyLoadFallback = () => <div className="min-h-[200px]" data-id="element-0"></div>;
export function App() {
  return <div className="w-full min-h-full bg-white font-sans" data-id="element-1">
      <Header data-id="element-2" />
      <SalesPopNotification data-id="element-3" />
      <Suspense fallback={<LazyLoadFallback data-id="element-5" />} data-id="element-4">
        <HeroSection data-id="element-6" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-8" />} data-id="element-7">
        <ProblemSolution data-id="element-9" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-11" />} data-id="element-10">
        <Features data-id="element-12" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-14" />} data-id="element-13">
        <Testimonials data-id="element-15" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-17" />} data-id="element-16">
        <Expert data-id="element-18" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-20" />} data-id="element-19">
        <Offer data-id="element-21" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-23" />} data-id="element-22">
        <Guarantee data-id="element-24" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-26" />} data-id="element-25">
        <FAQ data-id="element-27" />
      </Suspense>
      <Suspense fallback={<LazyLoadFallback data-id="element-29" />} data-id="element-28">
        <Footer data-id="element-30" />
      </Suspense>
    </div>;
}